






















































































































































































































import { Component, Vue } from "vue-property-decorator";
import fichajes_empleadoModule from "@/store/modules/fichajes_empleado-module";
import { API } from "@/shared/api";
import { JwtService } from "@/shared/services/JwtService";
import { authorizationService } from "@/shared/services/AuthorizationService";
import usuarioModule from "@/store/modules/usuario-module";
import tipos_fichajeModule from "@/store/modules/tipos_fichaje-module";
import { tipos_fichaje } from "@/shared/dtos/tipos_fichaje";
import alegaciones_loteModule from "@/store/modules/alegaciones_lote-module";
import { RouterNames } from "@/router/routernames";

interface TimeRecord {
  id: number;
  clockIn: string;
  clockOut?: string;
  Hours: number;
  status: "normal" | "late" | "early" | "overtime";
  date_in: Date;
  isRunning: boolean;
  tipo_fichaje: string;
  tipo_color?: string;
}

@Component({})
export default class fichajes_hoy extends Vue {
  public fichajesHoy: TimeRecord[] = [];
  public liveDurations: Record<number, string> = {};
  private interval: any = null;
  public relojColor: Record<number, string> = {};

  public datosPromedio: {
    hora_entrada_promedio: string;
    hora_salida_promedio: string;
    hora_entrada_minima: string;
    hora_entrada_maxima: string;
    hora_salida_minima: string;
    hora_salida_maxima: string;
    total_registros: number;
  } | null = null;
  public datosPromedioSeamana:
    | [
        {
          hora_entrada_promedio: string;
          hora_salida_promedio: string;
          hora_entrada_minima: string;
          hora_entrada_maxima: string;
          hora_salida_minima: string;
          hora_salida_maxima: string;
          total_registros: number;
          numero_dia_semana: number;
          nombre_dia_semana: string;
        }
      ]
    | null = null;
  public relojProgreso: Record<number, string> = {};

  public get userImageUrl() {
    return (
      API.webApiBaseImages +
      JwtService.jwtDecode().nameid +
      ".png?rnd=" +
      new Date().getTime()
    );
  }

  public get usuario() {
    return usuarioModule.mi_usuario;
  }

  async mounted() {
    usuarioModule.getmiusuario();
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    const mañana = new Date(hoy);
    mañana.setDate(mañana.getDate() + 1);
    await fichajes_empleadoModule
      .PostDashDatosPromedio({
        id: Number.parseInt(this.$route.params.id),
        fecha_desde: hoy,
        fecha_hasta: mañana,
      })
      .then((response) => {
        this.datosPromedio = response;
        console.log("Datos promedio:", this.datosPromedio);
      });
    await fichajes_empleadoModule
      .PostDashDatosPromedioSemana({
        id: Number.parseInt(this.$route.params.id),
        fecha_desde: hoy,
        fecha_hasta: mañana,
      })
      .then((response) => {
        this.datosPromedioSeamana = response;
        console.log("Datos promedio:", this.datosPromedio);
      });
    const data = await fichajes_empleadoModule.PostDashfichaje_hoy({
      id: Number.parseInt(this.$route.params.id),
      fecha_desde: hoy,
      fecha_hasta: mañana,
    });
    this.fichajesHoy = await Promise.all(
      data.map(async (record: any) => {
        const entrada = new Date(record.fecha_entrada);
        const salida = new Date(record.fecha_salida);
        const isSalidaInvalida =
          !record.fecha_salida ||
          salida.getFullYear() < 1900 ||
          salida.getTime() <= entrada.getTime();

        let horas = 0;
        let minutos = 0;

        if (!isSalidaInvalida) {
          const minutosTrabajados = Math.floor(
            (salida.getTime() - entrada.getTime()) / (1000 * 60)
          );
          horas = Math.floor(minutosTrabajados / 60);
          minutos = minutosTrabajados % 60;
        }

        let tipoNombre = "Desconocido";
        let tipoColor = "#adb5bd"; // gris claro por defecto

        try {
          const tipo = await tipos_fichajeModule.gettipos_fichaje(
            record.id_tipo_fichaje
          );
          tipoNombre = tipo!.nombre || "Desconocido";
          tipoColor = tipo!.color || "#adb5bd";
        } catch (e) {
          console.warn("No se pudo cargar el tipo de fichaje:", e);
        }

        return {
          id: record.id,
          clockIn: entrada.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
          clockOut: isSalidaInvalida
            ? undefined
            : salida.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              }),
          Hours: parseFloat(`${horas}.${minutos.toString().padStart(2, "0")}`),
          status: record.status,
          date_in: entrada,
          isRunning: isSalidaInvalida,
          tipo_fichaje: tipoNombre,
          tipo_color: tipoColor,
        };
      })
    );

    alegaciones_loteModule.getAlegacionPendientes();
    this.initLiveClock();
  }

  beforeDestroy() {
    clearInterval(this.interval);
  }

  initLiveClock() {
    this.interval = setInterval(() => {
      const now = new Date();
      this.fichajesHoy.forEach((fichaje) => {
        if (fichaje.isRunning) {
          const diffMs = now.getTime() - fichaje.date_in.getTime();
          const totalMinutes = Math.floor(diffMs / 60000);
          const horas = Math.floor(totalMinutes / 60);
          const minutos = totalMinutes % 60;

          this.$set(
            this.liveDurations,
            fichaje.id,
            `${horas}h ${minutos.toString().padStart(2, "0")}m`
          );

          const porcentaje = Math.min((totalMinutes / (8 * 60)) * 100, 100);
          const circunferencia = 2 * Math.PI * 45;
          const progreso = (circunferencia * porcentaje) / 100;

          // Color según progreso
          let color = "#3498db"; // Azul
          if (porcentaje >= 100) {
            color = "#e74c3c"; // Rojo
          } else if (porcentaje >= 75) {
            color = "#f39c12"; // Naranja
          }

          this.$set(
            this.relojProgreso,
            fichaje.id,
            `${progreso}, ${circunferencia}`
          );
          this.$set(this.relojColor, fichaje.id, color);
        }
      });
    }, 1000);
  }

  public formatDate(date: Date): string {
    return date.toLocaleDateString("es-ES", {
      weekday: "long",
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  public getStatusText(status: string): string {
    const map: Record<string, string> = {
      normal: "como de costumbre",
      late: "más tarde de lo habitual",
      early: "más temprano de lo habitual",
      overtime: "estas haciendo horas extra",
    };
    return map[status] || status;
  }

  public verLote(id: number) {
    var token = this.mis_alegaciones_pendientes.find((x) => x.id == id)!
      .token_grupo;
    this.$router.push({
      name: RouterNames.responderalegaciones,
      query: { token: token },
    }); /*
    this.$router.push({
      name: RouterNames.alegacioneslotevisor,
      params: { id: id.toString() },
    });*/
  }

  public get mis_alegaciones_pendientes() {
    return alegaciones_loteModule.mis_alegaciones_pendientes;
  }
}
